<div fxLayout="row" fxLayoutAlign="space-between end" class="header-create-section">

    <div>
        <h2 class="">
            {{ titulo }}</h2>

        <h1 class="text-4xl leading-normal mt-0 mb-2 font-semibold">
            {{ subTitulo }}
        </h1>
    </div>


    <button class="flex evk-button"
            *ngIf="canAdd" (click)="add()" mat-button style="width: fit-content;">
        <mat-icon style="color: #F9FAFB">add</mat-icon>
        {{ configExpediente.nombre }}
    </button>
</div>
<div class="backdrop-opacity-10 bg-card rounded-lg mb-5 pt-3 shadow-2xl search-bar" fxLayout="row wrap" fxLayout.xs="column" fxLayoutGap>

    <mat-form-field appearance="outline" fxFlex.xs="100%" fxFlex.sm="50%" fxFlex.md="25%" fxFlex.lg="25%" class="px-4">
        <mat-select placeholder="Seleccionar criterio" (selectionChange)="onFiltroChange($event)" #selectFiter>
            <mat-option>Limpiar...</mat-option>
            <ng-container *ngFor="let filter of filters;">
                <mat-option [value]="filter.id">{{filter.title}}</mat-option>
            </ng-container>
        </mat-select>
    </mat-form-field>

    <mat-form-field *ngIf='filtroSeleccionado == "fechaDeCreacion"' appearance="outline" fxFlex.xs="100%"
                    fxFlex.sm="50%" fxFlex.md="25%" fxFlex.lg="25%" class="px-4">
        <mat-label>Fecha de creación</mat-label>
        <input
            matInput
            [matDatepicker]="fechaCreacionPicker"
            placeholder="Fecha de creación"
            (blur)="onDateInputed($event)"
            [(ngModel)]="valoresFiltros.fechaDeCreacion">
        <mat-datepicker-toggle matSuffix [for]="fechaCreacionPicker"></mat-datepicker-toggle>
        <mat-datepicker #fechaCreacionPicker></mat-datepicker>
    </mat-form-field>

    <mat-form-field *ngIf='filtroSeleccionado == "folio"' appearance="outline" fxFlex.xs="100%" fxFlex.sm="50%"
                    fxFlex.md="25%" fxFlex.lg="25%" class="px-4">
        <mat-label>Número de folio</mat-label>
        <input placeholder="No. de folio" #query matInput cleanWhiteSpace [(ngModel)]="valoresFiltros.folio">
    </mat-form-field>

    <div fxFlex.xs="100%" fxFlex.sm="50%" fxFlex.md="25%" fxFlex.lg="25%" class="px-4 contenedor-filtro-buscar">
        <button (click)="filterBy()" [disabled]="!filtroSeleccionado" mat-raised-button
                class="evk-button"
                [ngClass]="{'disabled-evk-cuu': !filtroSeleccionado}">
            Buscar
        </button>
    </div>

</div>

<div  class="rounded-lg mt-10 shadow-2xl">

    <div class="bg-card rounded-lg p-10">
        <mat-table class="datos-table rounded-lg" #table [dataSource]="dataSource" matSort>
            <ng-container matColumnDef="folio">
                <mat-header-cell *matHeaderCellDef fxLayoutAlign="center center" mat-sort-header>Folio
                </mat-header-cell>
                <mat-cell *matCellDef="let row" fxLayoutAlign="center center">
                    <p class="text-truncate">{{validarFolio(row)}}</p>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="fechaCreacion">
                <mat-header-cell *matHeaderCellDef fxLayoutAlign="center center" mat-sort-header>Fecha creación
                </mat-header-cell>
                <mat-cell *matCellDef="let row" fxLayoutAlign="center center">
                    <p class="text-truncate">{{row.created | date:'dd/MM/yyyy HH:mm:ss'}}</p>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="acciones">
                <mat-header-cell *matHeaderCellDef fxLayoutAlign="center center" mat-sort-header>Acciones</mat-header-cell>
                <mat-cell *matCellDef="let row" fxLayoutAlign="center center" style="border: black;">
                    <button mat-icon-button [matMenuTriggerFor]="menu">
                        <mat-icon>settings</mat-icon>
                    </button>
                    <mat-menu #menu="matMenu">
                        <ng-template matMenuContent>
                            <button mat-menu-item (click)="edit(row)">
                                <mat-icon color="primary">remove_red_eye</mat-icon>
                                Ver detalle
                            </button>
                        </ng-template>
                    </mat-menu>
                </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="columns; sticky:true"></mat-header-row>
            <mat-row *matRowDef="let row; columns: columns;" matRipple></mat-row>
        </mat-table>

        <mat-paginator #paginator [length]="pageService.totalRows" [pageIndex]="pageService.pageIndex"
                       [pageSize]="pageService.pageSize" [pageSizeOptions]="pageService.pageSizeOptions"
                       (page)="changePageHandler($event)">
        </mat-paginator>

        <div *ngIf="dataSource.data.length === 0 && pageService.totalRows === 0">
            <div class="message-box ">
                No existen registros.
            </div>
        </div>

        <div *ngIf="dataSource.data.length === 0 && pageService.totalRows > 0">
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
            Cargando...
        </div>
    </div>

</div>
